module.exports = __webpack_public_path__ + "static/timeline2016-2-edffae2510f767ee48dc51d4a1c5ed9d.jpeg";